<script setup lang="ts">
defineProps({
  title: { type: String, required: true },
  slug: { type: String, required: true },
  description: { type: String, required: true },
  date: { type: String, required: true },
  location: { type: String, required: false },
  cover: { type: String, required: false },
})

</script>
<template>
  <li class="card flex flex-col lg:flex-row">
    <div class="media px-4">
      <div class="image-container">
        <img
          class="hover:scale-110 transition-all duration-500 cursor-pointer"
          :src="cover || 'https://assets.terreirovoritadasalmas.com.br/illustrations/default-cover-blank.svg'"
          alt=""
          onerror="this.onerror=null;this.src='https://assets.terreirovoritadasalmas.com.br/illustrations/default-cover-blank.svg';"
        >
      </div>
    </div>
    <!-- Content -->
    <div class="p-6 block">
      <nuxt-link :to="`/blog/${slug}`">
        <span class="text-3xl my-4 block font-bold hover:underline cursor-pointer">{{ title }}</span>
      </nuxt-link>
      <span class="block mb-2 font-light">{{ description }}</span>

      <!-- Date -->
      <div class="datetime py-4">
        <!-- Day -->
        <span>
          {{ $dayjs(date).format('LL') }}
        </span>
      </div>
    </div>
  </li>
</template>
<style lang="scss" scoped>
.card {
  background-color: #fff;
  position: relative;
  width: 100%;
  overflow: hidden;
}

.image-container {
  background-color: rgba(var(--theme-rgb), 0.065);
  border-radius: 8px;
  position: relative;
  width: 100%;
  height: 274px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

@media (screen(lg)) {
  .image-container {
    width: 416px;
    height: 274px;
  }
}

.media {
  position: relative;
}
</style>